module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withPropsFromContext = exports.getContextualizer = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	var getContextualizer = exports.getContextualizer = function getContextualizer(propTypes, targetProp) {
	  var ContextProps = function (_Component) {
	    _inherits(ContextProps, _Component);
	
	    function ContextProps() {
	      _classCallCheck(this, ContextProps);
	
	      return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    ContextProps.prototype.getChildContext = function getChildContext() {
	      var _this2 = this;
	
	      var props = Object.keys(this.props).reduce(function (x, key) {
	        if (key !== 'children') {
	          x[key] = _this2.props[key];
	        }
	
	        return x;
	      }, {});
	
	      return targetProp ? _defineProperty({}, targetProp, props) : props;
	    };
	
	    ContextProps.prototype.render = function render() {
	      return _react2.default.createElement(
	        'span',
	        null,
	        this.props.children
	      );
	    };
	
	    return ContextProps;
	  }(_react.Component);
	
	  ContextProps.displayName = 'ContextProps';
	
	  ContextProps.childContextTypes = targetProp ? _defineProperty({}, targetProp, _propTypes2.default.shape(propTypes)) : propTypes;
	  return ContextProps;
	};
	
	var withPropsFromContext = exports.withPropsFromContext = function withPropsFromContext(propList) {
	  return function (Target) {
	    var WithPropsFromContext = function (_Component2) {
	      _inherits(WithPropsFromContext, _Component2);
	
	      function WithPropsFromContext() {
	        _classCallCheck(this, WithPropsFromContext);
	
	        return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
	      }
	
	      WithPropsFromContext.prototype.render = function render() {
	        var _this4 = this;
	
	        var props = _extends({}, propList.reduce(function (x, prop) {
	          x[prop] = _this4.context[prop];
	
	          return x;
	        }, {}), this.props);
	
	        return _react2.default.createElement(Target, props);
	      };
	
	      return WithPropsFromContext;
	    }(_react.Component);
	
	    WithPropsFromContext.contextTypes = propList.reduce(function (x, prop) {
	      x[prop] = _propTypes2.default.any;
	      return x;
	    }, {});
	
	    WithPropsFromContext.displayName = 'withPropsFromContext(' + (Target.displayName || Target.name) + ')';
	
	    return WithPropsFromContext;
	  };
	};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = require("prop-types");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = require("react");

/***/ })
/******/ ]);
//# sourceMappingURL=index.js.map